export default __webpack_public_path__ + "static/quarter34-3674c8d27dc7a3f97c0728257e7306a8.png";